module.exports = __webpack_public_path__ + "images/emoji/school_satchel.63dea930ee3fbaeea24e.png";